var GOOGLE_MAPS_LIBRARIES, GOOGLE_MAPS_VERSION, GoogleMaps, MAP_PROXY_CHANNEL, MAP_PROXY_HOST_EU, MAP_PROXY_HOST_NA, callbacks, getMapProxyHost, loaded, loading;

MAP_PROXY_CHANNEL = 'layout-service';

MAP_PROXY_HOST_NA = '//mapproxy.groupon.com';

MAP_PROXY_HOST_EU = '//mapproxy-eu.groupon.com';

GOOGLE_MAPS_VERSION = 3;

GOOGLE_MAPS_LIBRARIES = ['geometry'];

loading = false;

callbacks = [];

loaded = function() {
  var cb, i, len, results;
  results = [];
  for (i = 0, len = callbacks.length; i < len; i++) {
    cb = callbacks[i];
    results.push(cb());
  }
  return results;
};

getMapProxyHost = function() {
  var country;
  country = document.head.getAttribute('data-country');
  if (country === 'US' || country === 'CL' || country === 'CO' || country === 'MX' || country === 'PA' || country === 'PE' || country === 'PR' || country === 'UY') {
    return MAP_PROXY_HOST_NA;
  } else {
    return MAP_PROXY_HOST_EU;
  }
};

module.exports = GoogleMaps = {
  load: function(cb) {
    var callbackName, query, ref;
    if (cb == null) {
      cb = function() {};
    }
    if (((ref = window.google) != null ? ref.maps : void 0) != null) {
      return cb();
    }
    callbacks.push(cb);
    if (loading) {
      return;
    }
    loading = true;
    callbackName = 'layoutServiceGoogleMapsCallback';
    window[callbackName] = loaded;
    query = $.param({
      sensor: false,
      v: GOOGLE_MAPS_VERSION,
      libraries: GOOGLE_MAPS_LIBRARIES.join(','),
      callback: callbackName,
      region: document.head.getAttribute('data-country') || 'US',
      language: document.head.getAttribute('data-language') || 'en-US',
      channel: MAP_PROXY_CHANNEL
    });
    return $.getScript((getMapProxyHost()) + "/maps/api/js?" + query).fail(function() {
      return cb(new Error('Unable to load Google Maps Library'));
    });
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9tb2R1bGVzL2dvb2dsZV9tYXBzL2Zyb250ZW5kL2dvb2dsZV9tYXBzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9qcHZlcmRlam8vR3JvdXBvbi9zbHMvbW9kdWxlcy9nb29nbGVfbWFwcy9mcm9udGVuZC9nb29nbGVfbWFwcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR0EsSUFBQTs7QUFBQSxpQkFBQSxHQUFvQjs7QUFDcEIsaUJBQUEsR0FBb0I7O0FBQ3BCLGlCQUFBLEdBQW9COztBQUVwQixtQkFBQSxHQUFzQjs7QUFDdEIscUJBQUEsR0FBd0IsQ0FBQyxVQUFEOztBQUV4QixPQUFBLEdBQVU7O0FBQ1YsU0FBQSxHQUFZOztBQUVaLE1BQUEsR0FBUyxTQUFBO0FBQ1AsTUFBQTtBQUFBO09BQUEsMkNBQUE7O2lCQUFBLEVBQUEsQ0FBQTtBQUFBOztBQURPOztBQUdULGVBQUEsR0FBa0IsU0FBQTtBQUNoQixNQUFBO0VBQUEsT0FBQSxHQUFVLFFBQVEsQ0FBQyxJQUFJLENBQUMsWUFBZCxDQUEyQixjQUEzQjtFQUdWLElBQUcsT0FBQSxLQUFZLElBQVosSUFBQSxPQUFBLEtBQWtCLElBQWxCLElBQUEsT0FBQSxLQUF3QixJQUF4QixJQUFBLE9BQUEsS0FBOEIsSUFBOUIsSUFBQSxPQUFBLEtBQW9DLElBQXBDLElBQUEsT0FBQSxLQUEwQyxJQUExQyxJQUFBLE9BQUEsS0FBZ0QsSUFBaEQsSUFBQSxPQUFBLEtBQXNELElBQXpEO1dBQ0Usa0JBREY7R0FBQSxNQUFBO1dBR0Usa0JBSEY7O0FBSmdCOztBQVNsQixNQUFNLENBQUMsT0FBUCxHQUFpQixVQUFBLEdBRWY7RUFBQSxJQUFBLEVBQU0sU0FBQyxFQUFEO0FBQ0osUUFBQTs7TUFBQSxLQUFNLFNBQUEsR0FBQTs7SUFDTixJQUFlLDJEQUFmO0FBQUEsYUFBTyxFQUFBLENBQUEsRUFBUDs7SUFDQSxTQUFTLENBQUMsSUFBVixDQUFlLEVBQWY7SUFFQSxJQUFVLE9BQVY7QUFBQSxhQUFBOztJQUNBLE9BQUEsR0FBVTtJQUVWLFlBQUEsR0FBZTtJQUNmLE1BQU8sQ0FBQSxZQUFBLENBQVAsR0FBdUI7SUFFdkIsS0FBQSxHQUFRLENBQUMsQ0FBQyxLQUFGLENBQ047TUFBQSxNQUFBLEVBQVEsS0FBUjtNQUNBLENBQUEsRUFBRyxtQkFESDtNQUVBLFNBQUEsRUFBVyxxQkFBcUIsQ0FBQyxJQUF0QixDQUEyQixHQUEzQixDQUZYO01BR0EsUUFBQSxFQUFVLFlBSFY7TUFJQSxNQUFBLEVBQVEsUUFBUSxDQUFDLElBQUksQ0FBQyxZQUFkLENBQTJCLGNBQTNCLENBQUEsSUFBOEMsSUFKdEQ7TUFLQSxRQUFBLEVBQVUsUUFBUSxDQUFDLElBQUksQ0FBQyxZQUFkLENBQTJCLGVBQTNCLENBQUEsSUFBK0MsT0FMekQ7TUFNQSxPQUFBLEVBQVMsaUJBTlQ7S0FETTtXQVNSLENBQUMsQ0FBQyxTQUFGLENBQWMsQ0FBQyxlQUFBLENBQUEsQ0FBRCxDQUFBLEdBQW1CLGVBQW5CLEdBQWtDLEtBQWhELENBQXdELENBQUMsSUFBekQsQ0FBOEQsU0FBQTthQUM1RCxFQUFBLENBQU8sSUFBQSxLQUFBLENBQU0sb0NBQU4sQ0FBUDtJQUQ0RCxDQUE5RDtFQXBCSSxDQUFOIn0=
